export default "__VITE_ASSET__dILI0a4C__"